var _defs, _image, _g, _g2, _g3, _rect, _text, _text2, _rect2, _text3, _rect3, _text4, _path, _path2, _path3, _g4, _path4, _text5, _text6, _g5, _path5, _text7, _text8, _g6, _path6, _text9, _path7, _g7, _path8, _text10, _text11, _g8, _path9, _text12, _text13, _g9, _path10, _text14, _path11, _g10, _path12, _text15, _text16, _g11, _path13, _text17, _text18, _g12, _path14, _text19, _path15, _g13, _path16, _text20, _text21, _g14, _path17, _text22, _text23, _g15, _path18, _text24, _g16, _path19, _text25, _text26, _g17, _path20, _text27, _text28, _g18, _path21, _text29, _path22, _path23, _path24, _text30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgendarsesso2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ctas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-19, .cls-22, .cls-23, .cls-26, .cls-4, .cls-40 {\n        fill: #4da747;\n      }\n\n      .cls-10, .cls-12, .cls-2, .cls-4, .cls-6 {\n        font-size: 15px;\n      }\n\n      .cls-18, .cls-2, .cls-20, .cls-25, .cls-27, .cls-28, .cls-37, .cls-38 {\n        fill: #fff;\n      }\n\n      .cls-19, .cls-2, .cls-26, .cls-29, .cls-36, .cls-4, .cls-40, .cls-6, .cls-8 {\n        text-anchor: middle;\n      }\n\n      .cls-10, .cls-12, .cls-19, .cls-2, .cls-21, .cls-22, .cls-24, .cls-26, .cls-29, .cls-31, .cls-32, .cls-36, .cls-4, .cls-40, .cls-6, .cls-8 {\n        font-family: Ubuntu;\n      }\n\n      .cls-13, .cls-19, .cls-2, .cls-21, .cls-22, .cls-24, .cls-26, .cls-29, .cls-31, .cls-32, .cls-36, .cls-4, .cls-6, .cls-8 {\n        font-weight: 700;\n      }\n\n      .cls-2, .cls-4, .cls-6 {\n        text-transform: uppercase;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #4da747;\n      }\n\n      .cls-28, .cls-3 {\n        stroke-width: 1px;\n      }\n\n      .cls-5 {\n        fill: #e3e0e0;\n      }\n\n      .cls-10, .cls-12, .cls-31, .cls-42, .cls-6 {\n        fill: #999;\n      }\n\n      .cls-15, .cls-7 {\n        fill: #fdfdfd;\n      }\n\n      .cls-7 {\n        filter: url(#filter);\n      }\n\n      .cls-21, .cls-24, .cls-31, .cls-8 {\n        font-size: 14px;\n      }\n\n      .cls-8 {\n        fill: #272b2e;\n      }\n\n      .cls-10, .cls-12, .cls-9 {\n        font-weight: 300;\n      }\n\n      .cls-10 {\n        text-anchor: end;\n      }\n\n      .cls-11 {\n        fill: #ddd;\n      }\n\n      .cls-14 {\n        fill: #262b2d;\n      }\n\n      .cls-15, .cls-16, .cls-17, .cls-18, .cls-20, .cls-23, .cls-25, .cls-27, .cls-28, .cls-30, .cls-33, .cls-34, .cls-35, .cls-37, .cls-38, .cls-39 {\n        fill-rule: evenodd;\n      }\n\n      .cls-16 {\n        fill: #cfcfcf;\n      }\n\n      .cls-17 {\n        fill: #b8e7c7;\n        filter: url(#filter-2);\n      }\n\n      .cls-17, .cls-27, .cls-37, .cls-38 {\n        opacity: 0.9;\n      }\n\n      .cls-19, .cls-29 {\n        font-size: 13px;\n      }\n\n      .cls-20, .cls-30 {\n        opacity: 0.2;\n      }\n\n      .cls-21 {\n        fill: #010101;\n      }\n\n      .cls-22, .cls-32 {\n        font-size: 10px;\n      }\n\n      .cls-25, .cls-35 {\n        opacity: 0.8;\n      }\n\n      .cls-26, .cls-36 {\n        font-size: 24px;\n      }\n\n      .cls-27 {\n        filter: url(#filter-3);\n      }\n\n      .cls-28 {\n        stroke: #e19baa;\n      }\n\n      .cls-29, .cls-32 {\n        fill: #dba3ae;\n      }\n\n      .cls-30 {\n        fill: #dfdfdf;\n      }\n\n      .cls-33 {\n        fill: #f0cad2;\n      }\n\n      .cls-34, .cls-35 {\n        fill: #fcf4f6;\n      }\n\n      .cls-36 {\n        fill: #e19baa;\n      }\n\n      .cls-37 {\n        filter: url(#filter-4);\n      }\n\n      .cls-38 {\n        filter: url(#filter-5);\n      }\n\n      .cls-39 {\n        fill: #dbdce0;\n      }\n\n      .cls-40 {\n        font-size: 13.629px;\n        font-weight: 500;\n      }\n\n      .cls-41 {\n        fill: #e9afbb;\n      }\n\n      .cls-43 {\n        fill: #c1bfbf;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: -18,
    y: 153,
    width: 1651,
    height: 83,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dx: 4.95,
    dy: 4.95,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.162
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodOpacity: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    x: 1322,
    y: -314,
    width: 310,
    height: 451,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dx: 4.5,
    dy: 5.362,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.162
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#303030",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3",
    x: 987,
    y: -314,
    width: 310,
    height: 451,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dx: 4.5,
    dy: 5.362,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.162
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#303030",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4",
    x: 652,
    y: -314,
    width: 310,
    height: 451,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dx: 4.5,
    dy: 5.362,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.162
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#303030",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-5",
    x: 317,
    y: -314,
    width: 310,
    height: 451,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dx: 4.5,
    dy: 5.362,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.162
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#303030",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 28,
    height: 28,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACtUlEQVRIia2WT0hUURTGf/NGK4QKogEj2kRCRYLTIpIiokV/JGlRCBktwiKwRStBhLaGtogg3FTQpj/0z0VlWNBKSdoUuGhhQZtowCIwDDK0OPC94faae+dO+sEM9913zvfd++45555c+50DVEEeMKM2YCfQBKySy3dgCngFjAAvgF8hurrAu3qgG+gB1ntsVgLb9TsHfAYGgSFgrhbBFuA2sMWZmwZeApNASXONwFZgn8brgMvAWeA48DZG8ChwC1iuZ/tc/cAzYN6zQPvsB4FeYDewGZgATgL3XcOkgtg9if0AzgC7gCcBMfTuKbAHOAXMiuMu0OwTbNHObO6LVnod+B0QysJsb8q3pAD66dqkn7ReZ5bubD/wpgahLOzsNgHLgG+VBLudADm/SLEUs/r9hUQH3qNJC5AbSyDmRaKkTvOsv8Yzc2ELXx0j2KbxtEL/f1AAXivY9ob861SuUFKHQt+Hgny36f2aajts0ngyYJdTMucy81mxAeCRh2ODlcLEKcQljyE623fAsELdJ9br8d8BfLR0yVYaH1K7I8ADBVmsGKo2xrHR/mY02RhwuAA81rgdeF+DmMs9k+g+I1vzMrCr5pgjuqIGMZd7KlFVR1dMPkJ0WM8XI8Xy4jZMJLqpURAcquI8pxtlLdAXIYY4CxqPmOAo8EkTfRVCPwurRF8jxXLOwkxjNFGyX9JkK9AVSRaDLnEijfk03IeUZ4YrQHEJxIriQtymUc4vuyg7dVk2AM8XKVoUR4M4O9Nuzk18uzRPAAsKijHgdMSZusjJZ0wcC+IsN1PZSvMQ6HB2eg0YBw5XSZm8bMblk+6sQ5xlVOrazOCD0ya2KuF9bWKz8qzgcNiZ2Wf8p00Mdd4xjXAWFvoWjRYgFTvwUOdtDhZlVwOtvtVhK41WrayAWE7771TgDwRkmioRtR/WAAAAAElFTkSuQmCC"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "logo",
    x: -139,
    y: -568,
    width: 183,
    height: 58,
    xlinkHref: "data:img/png;base64,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"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "selecionar_nenhum",
    "data-name": "selecionar nenhum"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_1",
    "data-name": "Rounded Rectangle 1",
    className: "cls-1",
    x: 995.25,
    y: 318.094,
    width: 366,
    height: 72,
    rx: 36,
    ry: 36
  }), /*#__PURE__*/React.createElement("text", {
    id: "Agendar_sess\\xE3o",
    "data-name": "Agendar sess\\xE3o",
    className: "cls-2",
    transform: "translate(-3.956 -1809.696) scale(1.548 1.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "pr\xF3xima etapa")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "selecionar_todos",
    "data-name": "selecionar todos"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_1-2",
    "data-name": "Rounded Rectangle 1",
    className: "cls-3",
    x: 612.375,
    y: 317.594,
    width: 366,
    height: 72,
    rx: 36,
    ry: 36
  }), /*#__PURE__*/React.createElement("text", {
    id: "Agendar_sess\\xE3o-2",
    "data-name": "Agendar sess\\xE3o",
    className: "cls-4",
    transform: "translate(-386.832 -1810.197) scale(1.548 1.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "selecionar todos")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "voltar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_1-3",
    "data-name": "Rounded Rectangle 1",
    className: "cls-5",
    x: 229.5,
    y: 318.094,
    width: 366,
    height: 72,
    rx: 36,
    ry: 36
  }), /*#__PURE__*/React.createElement("text", {
    id: "Agendar_sess\\xE3o-3",
    "data-name": "Agendar sess\\xE3o",
    className: "cls-6",
    transform: "translate(-769.72 -1809.689) scale(1.548 1.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "Voltar")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_2",
    "data-name": "Rounded Rectangle 2",
    className: "cls-7",
    x: -14,
    y: 157,
    width: 1632,
    height: 64,
    rx: 32,
    ry: 32
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_30_08_2020",
    "data-name": "30/08/2020",
    className: "cls-8",
    transform: "translate(618.765 -164.467) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "03", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, "/"), "09", /*#__PURE__*/React.createElement("tspan", null, "/"), "2020"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Pr\\xF3ximo_Pagamento:",
    "data-name": "Pr\\xF3ximo Pagamento:",
    className: "cls-10",
    transform: "translate(234.869 -165.46) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "Data m\xEDnima para agendamento:"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Path_copy",
    "data-name": "Path copy",
    className: "cls-11",
    x: 542,
    y: 182,
    width: 1,
    height: 14
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Dura\\xE7\\xE3o_da_sess\\xE3o:_01:00",
    "data-name": "Dura\\xE7\\xE3o da sess\\xE3o: 01:00",
    className: "cls-12",
    transform: "translate(169.581 -165.009) scale(1.075 1.075)"
  }, "Dura\xE7\xE3o da sess\xE3o:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14"
  }, "01:00")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    className: "cls-11",
    x: 307,
    y: 182,
    width: 1,
    height: 14
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "Regi\\xF5es_contratadas:",
    "data-name": "Regi\\xF5es contratadas:",
    className: "cls-12",
    transform: "translate(-144.593 -165.46) scale(1.075 1.075)"
  }, "Regi\xF5es contratadas:", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14"
  }, "Axilas, Pernas")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-15",
    d: "M1700.35-94.164c0-15.188-11.9-27.5-26.59-27.5h-1.81c-14.69,0-26.6,12.312-26.6,27.5h0c0,15.188,11.91,27.5,26.6,27.5h1.81c14.69,0,26.59-12.312,26.59-27.5h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-16",
    d: "M1670.1-85.914l9.17-8.25-9.17-8.25v16.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-17",
    d: "M1327.14-270.179c0-26.1,10.46-39.5,30.83-39.5h228.34c20.38,0,30.83,13.4,30.83,39.5V81.828c0,26.1-10.45,39.5-30.83,39.5H1357.97c-20.37,0-30.83-13.4-30.83-39.5V-270.179Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "cta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_Auto_Shape",
    "data-name": "Rounded Rectangle Auto Shape",
    className: "cls-18",
    d: "M1337.14,86.324c0-13.807,10.61-25,23.69-25h222.62c13.09,0,23.69,11.193,23.69,25h0c0,13.807-10.6,25-23.69,25H1360.83c-13.08,0-23.69-11.193-23.69-25h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DETALHES",
    className: "cls-19",
    transform: "translate(1179.634 -265.917) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "SELECIONADO")), /*#__PURE__*/React.createElement("use", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    x: 1352,
    y: 72,
    xlinkHref: "#image"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "linha",
    className: "cls-20",
    d: "M1327.14,50.324h290v1h-290v-1Z"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "_15_09_2020_\\xE0s_14:30",
    "data-name": "15/09/2020 \\xE0s 14:30",
    className: "cls-21",
    transform: "translate(1226.925 -324.915) scale(1.075 1.075)"
  }, "15/09/2020 \xE0s 14:30")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "DATA_HOR\\xC1RIO_DA_SESS",
    "data-name": "DATA/HOR\\xC1RIO DA SESS",
    className: "cls-22",
    transform: "translate(1227.924 -342.935) scale(1.075 1.075)"
  }, "AGENDAMENTO A PARTIR DO DIA")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icon_data",
    "data-name": "icon data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    className: "cls-23",
    d: "M1342.14,17.324a18,18,0,1,1,18,18A18,18,0,0,1,1342.14,17.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Composite_Path",
    "data-name": "Composite Path",
    className: "cls-18",
    d: "M1365.64,11.824h-1.5v-1a0.5,0.5,0,0,0-.5-0.5,0.5,0.5,0,0,0-.5.5v1h-6v-1a0.5,0.5,0,0,0-.5-0.5,0.5,0.5,0,0,0-.5.5v1h-1.5a1.5,1.5,0,0,0-1.5,1.5v9.5a1.5,1.5,0,0,0,1.5,1.5h11a1.5,1.5,0,0,0,1.5-1.5v-9.5A1.5,1.5,0,0,0,1365.64,11.824Zm-11,1h1.5v1a0.5,0.5,0,0,0,.5.5,0.5,0.5,0,0,0,.5-0.5v-1h6v1a0.5,0.5,0,0,0,.5.5,0.5,0.5,0,0,0,.5-0.5v-1h1.5a0.5,0.5,0,0,1,.5.5v2h-12v-2A0.5,0.5,0,0,1,1354.64,12.824Zm11,10.5h-11a0.5,0.5,0,0,1-.5-0.5v-6.5h12v6.5A0.5,0.5,0,0,1,1365.64,23.324Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "linha-2",
    "data-name": "linha",
    className: "cls-20",
    d: "M1327.14-16.676h290v1h-290v-1Z"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "_4_10",
    "data-name": "4/10",
    className: "cls-24",
    transform: "translate(1226.925 -393.915) scale(1.075 1.075)"
  }, "4/10")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "PR\\xD3XIMA_SESS\\xC3O",
    "data-name": "PR\\xD3XIMA SESS\\xC3O",
    className: "cls-22",
    transform: "translate(1227.924 -410.935) scale(1.075 1.075)"
  }, "PR\xD3XIMA SESS\xC3O")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "icon_sessao",
    "data-name": "icon sessao"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-2",
    "data-name": "Ellipse",
    className: "cls-23",
    d: "M1342.14-49.676a18,18,0,0,1,18-18,18,18,0,0,1,18,18,18,18,0,0,1-18,18A18,18,0,0,1,1342.14-49.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    className: "cls-25",
    d: "M1367.14-47.379l-2.36-3.111,2.36-3.111h-4v-1.037h-7v-0.907a0.137,0.137,0,0,0-.15-0.13h-0.7a0.14,0.14,0,0,0-.15.126V-41.8a0.14,0.14,0,0,0,.15.126h0.7a0.134,0.134,0,0,0,.15-0.126v-6.615h4v1.037h7Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "linha-3",
    "data-name": "linha",
    className: "cls-20",
    d: "M1327.14-83.676h290v1h-290v-1Z"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "Axilas",
    className: "cls-26",
    x: 1327.142,
    y: -129.676
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1327.142
  }, "Pernas"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-27",
    d: "M992.639-270.179c0-26.1,10.461-39.5,30.831-39.5h228.34c20.37,0,30.83,13.4,30.83,39.5V81.828c0,26.1-10.46,39.5-30.83,39.5H1023.47c-20.37,0-30.831-13.4-30.831-39.5V-270.179Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "cta-2",
    "data-name": "cta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_Auto_Shape-2",
    "data-name": "Rounded Rectangle Auto Shape",
    className: "cls-28",
    d: "M1002.64,86.324c0-13.807,10.61-25,23.69-25h222.62c13.08,0,23.69,11.193,23.69,25h0c0,13.807-10.61,25-23.69,25H1026.33c-13.08,0-23.69-11.193-23.69-25h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DETALHES-2",
    "data-name": "DETALHES",
    className: "cls-29",
    transform: "translate(845.131 -265.917) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "SELECIONAR")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "linha-4",
    "data-name": "linha",
    className: "cls-30",
    d: "M992.639,50.324h290v1h-290v-1Z"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "_15_09_2020_\\xE0s_14:30-2",
    "data-name": "15/09/2020 \\xE0s 14:30",
    className: "cls-31",
    transform: "translate(892.422 -324.915) scale(1.075 1.075)"
  }, "15/09/2020 \xE0s 14:30")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "DATA_HOR\\xC1RIO_DA_SESS-2",
    "data-name": "DATA/HOR\\xC1RIO DA SESS",
    className: "cls-32",
    transform: "translate(893.422 -342.935) scale(1.075 1.075)"
  }, "AGENDAMENTO A PARTIR DO DIA")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "icon_data-2",
    "data-name": "icon data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-3",
    "data-name": "Ellipse",
    className: "cls-33",
    d: "M1007.64,17.324a18,18,0,1,1,18,18A18,18,0,0,1,1007.64,17.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Composite_Path-2",
    "data-name": "Composite Path",
    className: "cls-34",
    d: "M1031.14,11.824h-1.5v-1a0.5,0.5,0,0,0-1,0v1h-6v-1a0.5,0.5,0,1,0-1,0v1h-1.5a1.5,1.5,0,0,0-1.5,1.5v9.5a1.5,1.5,0,0,0,1.5,1.5h11a1.5,1.5,0,0,0,1.5-1.5v-9.5A1.5,1.5,0,0,0,1031.14,11.824Zm-11,1h1.5v1a0.5,0.5,0,0,0,1,0v-1h6v1a0.5,0.5,0,1,0,1,0v-1h1.5a0.5,0.5,0,0,1,.5.5v2h-12v-2A0.5,0.5,0,0,1,1020.14,12.824Zm11,10.5h-11a0.5,0.5,0,0,1-.5-0.5v-6.5h12v6.5A0.5,0.5,0,0,1,1031.14,23.324Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "linha-5",
    "data-name": "linha",
    className: "cls-30",
    d: "M992.639-16.676h290v1h-290v-1Z"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "_4_10-2",
    "data-name": "4/10",
    className: "cls-31",
    transform: "translate(892.422 -393.915) scale(1.075 1.075)"
  }, "4/10")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "PR\\xD3XIMA_SESS\\xC3O-2",
    "data-name": "PR\\xD3XIMA SESS\\xC3O",
    className: "cls-32",
    transform: "translate(893.422 -410.935) scale(1.075 1.075)"
  }, "PR\xD3XIMA SESS\xC3O")), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "icon_sessao-2",
    "data-name": "icon sessao"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-4",
    "data-name": "Ellipse",
    className: "cls-33",
    d: "M1007.64-49.676a18,18,0,0,1,18-18,18,18,0,0,1,18,18,18,18,0,0,1-18,18A18,18,0,0,1,1007.64-49.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    className: "cls-35",
    d: "M1032.64-47.379l-2.36-3.111,2.36-3.111h-4v-1.037h-7v-0.907a0.143,0.143,0,0,0-.15-0.13h-0.7a0.14,0.14,0,0,0-.15.126V-41.8a0.14,0.14,0,0,0,.15.126h0.7a0.14,0.14,0,0,0,.15-0.126v-6.615h4v1.037h7Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "linha-6",
    "data-name": "linha",
    className: "cls-30",
    d: "M992.639-83.676h290v1h-290v-1Z"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "Axilas-2",
    "data-name": "Axilas",
    className: "cls-36",
    x: 992.64,
    y: -129.676
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 992.64
  }, "Pernas"))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "bg-3",
    "data-name": "bg",
    className: "cls-37",
    d: "M657.044-270.179c0-26.1,10.457-39.5,30.831-39.5H916.214c20.374,0,30.83,13.4,30.83,39.5V81.828c0,26.1-10.456,39.5-30.83,39.5H687.875c-20.374,0-30.831-13.4-30.831-39.5V-270.179Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "cta-3",
    "data-name": "cta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_Auto_Shape-3",
    "data-name": "Rounded Rectangle Auto Shape",
    className: "cls-28",
    d: "M667.045,86.324c0-13.807,10.605-25,23.689-25H913.355c13.084,0,23.69,11.193,23.69,25h0c0,13.807-10.606,25-23.69,25H690.734c-13.084,0-23.689-11.193-23.689-25h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DETALHES-3",
    "data-name": "DETALHES",
    className: "cls-29",
    transform: "translate(509.534 -265.917) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "SELECIONAR")))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "linha-7",
    "data-name": "linha",
    className: "cls-30",
    d: "M657.044,50.324h290v1h-290v-1Z"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    id: "_15_09_2020_\\xE0s_14:30-3",
    "data-name": "15/09/2020 \\xE0s 14:30",
    className: "cls-31",
    transform: "translate(556.825 -324.915) scale(1.075 1.075)"
  }, "15/09/2020 \xE0s 14:30")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    id: "DATA_HOR\\xC1RIO_DA_SESS-3",
    "data-name": "DATA/HOR\\xC1RIO DA SESS",
    className: "cls-32",
    transform: "translate(557.829 -342.935) scale(1.075 1.075)"
  }, "AGENDAMENTO A PARTIR DO DIA")), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "icon_data-3",
    "data-name": "icon data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-5",
    "data-name": "Ellipse",
    className: "cls-33",
    d: "M672.044,17.324a18,18,0,1,1,18,18A18,18,0,0,1,672.044,17.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Composite_Path-3",
    "data-name": "Composite Path",
    className: "cls-34",
    d: "M695.545,11.824h-1.5v-1a0.5,0.5,0,0,0-1,0v1h-6v-1a0.5,0.5,0,0,0-1,0v1h-1.5a1.5,1.5,0,0,0-1.5,1.5v9.5a1.5,1.5,0,0,0,1.5,1.5h11a1.5,1.5,0,0,0,1.5-1.5v-9.5A1.5,1.5,0,0,0,695.545,11.824Zm-11,1h1.5v1a0.5,0.5,0,0,0,1,0v-1h6v1a0.5,0.5,0,0,0,1,0v-1h1.5a0.5,0.5,0,0,1,.5.5v2h-12v-2A0.5,0.5,0,0,1,684.544,12.824Zm11,10.5h-11a0.5,0.5,0,0,1-.5-0.5v-6.5h12v6.5A0.5,0.5,0,0,1,695.545,23.324Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "linha-8",
    "data-name": "linha",
    className: "cls-30",
    d: "M657.044-16.676h290v1h-290v-1Z"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    id: "_4_10-3",
    "data-name": "4/10",
    className: "cls-31",
    transform: "translate(556.825 -393.915) scale(1.075 1.075)"
  }, "4/10")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    id: "PR\\xD3XIMA_SESS\\xC3O-3",
    "data-name": "PR\\xD3XIMA SESS\\xC3O",
    className: "cls-32",
    transform: "translate(557.825 -410.935) scale(1.075 1.075)"
  }, "PR\xD3XIMA SESS\xC3O")), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "icon_sessao-3",
    "data-name": "icon sessao"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-6",
    "data-name": "Ellipse",
    className: "cls-33",
    d: "M672.044-49.676a18,18,0,0,1,18-18,18,18,0,0,1,18,18,18,18,0,0,1-18,18A18,18,0,0,1,672.044-49.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-35",
    d: "M697.045-47.379l-2.361-3.111,2.361-3.111h-4v-1.037h-7v-0.907a0.14,0.14,0,0,0-.151-0.13h-0.7a0.138,0.138,0,0,0-.152.126V-41.8a0.138,0.138,0,0,0,.152.126h0.7a0.137,0.137,0,0,0,.151-0.126v-6.615h4v1.037h7Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "linha-9",
    "data-name": "linha",
    className: "cls-30",
    d: "M657.044-83.676h290v1h-290v-1Z"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    id: "Axilas-3",
    "data-name": "Axilas",
    className: "cls-36",
    x: 657.043,
    y: -129.676
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 657.043
  }, "Axilas"))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "bg-4",
    "data-name": "bg",
    className: "cls-38",
    d: "M322.072-270.179c0-26.1,10.457-39.5,30.83-39.5h228.34c20.373,0,30.83,13.4,30.83,39.5V81.828c0,26.1-10.457,39.5-30.83,39.5H352.9c-20.373,0-30.83-13.4-30.83-39.5V-270.179Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "cta-4",
    "data-name": "cta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_Auto_Shape-4",
    "data-name": "Rounded Rectangle Auto Shape",
    className: "cls-28",
    d: "M332.072,86.324c0-13.807,10.606-25,23.689-25H578.383c13.083,0,23.689,11.193,23.689,25h0c0,13.807-10.606,25-23.689,25H355.761c-13.083,0-23.689-11.193-23.689-25h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DETALHES-4",
    "data-name": "DETALHES",
    className: "cls-29",
    transform: "translate(174.563 -265.917) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "SELECIONAR")))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "linha-10",
    "data-name": "linha",
    className: "cls-30",
    d: "M322.072,50.324h290v1h-290v-1Z"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    id: "_15_09_2020_\\xE0s_14:30-4",
    "data-name": "15/09/2020 \\xE0s 14:30",
    className: "cls-31",
    transform: "translate(221.854 -324.915) scale(1.075 1.075)"
  }, "15/09/2020 \xE0s 14:30")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    id: "DATA_HOR\\xC1RIO_DA_SESS-4",
    "data-name": "DATA/HOR\\xC1RIO DA SESS",
    className: "cls-32",
    transform: "translate(222.855 -342.935) scale(1.075 1.075)"
  }, "AGENDAMENTO A PARTIR DO DIA")), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "icon_data-4",
    "data-name": "icon data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-7",
    "data-name": "Ellipse",
    className: "cls-33",
    d: "M337.072,17.324a18,18,0,1,1,18,18A18,18,0,0,1,337.072,17.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Composite_Path-4",
    "data-name": "Composite Path",
    className: "cls-34",
    d: "M360.572,11.824h-1.5v-1a0.5,0.5,0,0,0-1,0v1h-6v-1a0.5,0.5,0,0,0-1,0v1h-1.5a1.5,1.5,0,0,0-1.5,1.5v9.5a1.5,1.5,0,0,0,1.5,1.5h11a1.5,1.5,0,0,0,1.5-1.5v-9.5A1.5,1.5,0,0,0,360.572,11.824Zm-11,1h1.5v1a0.5,0.5,0,1,0,1,0v-1h6v1a0.5,0.5,0,1,0,1,0v-1h1.5a0.5,0.5,0,0,1,.5.5v2h-12v-2A0.5,0.5,0,0,1,349.572,12.824Zm11,10.5h-11a0.5,0.5,0,0,1-.5-0.5v-6.5h12v6.5A0.5,0.5,0,0,1,360.572,23.324Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "linha-11",
    "data-name": "linha",
    className: "cls-30",
    d: "M322.072-16.676h290v1h-290v-1Z"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    id: "_4_10-4",
    "data-name": "4/10",
    className: "cls-31",
    transform: "translate(221.855 -393.915) scale(1.075 1.075)"
  }, "4/10")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    id: "PR\\xD3XIMA_SESS\\xC3O-4",
    "data-name": "PR\\xD3XIMA SESS\\xC3O",
    className: "cls-32",
    transform: "translate(222.853 -410.935) scale(1.075 1.075)"
  }, "PR\xD3XIMA SESS\xC3O")), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "icon_sessao-4",
    "data-name": "icon sessao"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-8",
    "data-name": "Ellipse",
    className: "cls-33",
    d: "M337.072-49.676a18,18,0,0,1,18-18,18,18,0,0,1,18,18,18,18,0,0,1-18,18A18,18,0,0,1,337.072-49.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    className: "cls-35",
    d: "M362.072-47.379l-2.36-3.111,2.36-3.111h-4v-1.037h-7v-0.907a0.141,0.141,0,0,0-.151-0.13h-0.7a0.138,0.138,0,0,0-.152.126V-41.8a0.138,0.138,0,0,0,.152.126h0.7a0.138,0.138,0,0,0,.151-0.126v-6.615h4v1.037h7Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "linha-12",
    "data-name": "linha",
    className: "cls-30",
    d: "M322.072-83.676h290v1h-290v-1Z"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    id: "Axilas-4",
    "data-name": "Axilas",
    className: "cls-36",
    x: 322.072,
    y: -129.676
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 322.072
  }, "Pernas"))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "cta-5",
    "data-name": "cta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_Auto_Shape-5",
    "data-name": "Rounded Rectangle Auto Shape",
    className: "cls-18",
    d: "M-3.857,86.324c0-13.807,10.606-25,23.689-25H242.453c13.084,0,23.69,11.193,23.69,25h0c0,13.807-10.606,25-23.69,25H19.832c-13.083,0-23.689-11.193-23.689-25h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DETALHES-5",
    "data-name": "DETALHES",
    className: "cls-19",
    transform: "translate(-161.366 -265.917) scale(1.075 1.075)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "SELECIONADO")), /*#__PURE__*/React.createElement("use", {
    id: "Vector_Smart_Object-2",
    "data-name": "Vector Smart Object",
    x: 11,
    y: 72,
    xlinkHref: "#image"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "linha-13",
    "data-name": "linha",
    className: "cls-20",
    d: "M-13.857,50.324h290v1h-290v-1Z"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    id: "_15_09_2020_\\xE0s_14:30-5",
    "data-name": "15/09/2020 \\xE0s 14:30",
    className: "cls-21",
    transform: "translate(-114.076 -324.915) scale(1.075 1.075)"
  }, "15/09/2020 \xE0s 14:30")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    id: "DATA_HOR\\xC1RIO_DA_SESS-5",
    "data-name": "DATA/HOR\\xC1RIO DA SESS",
    className: "cls-22",
    transform: "translate(-113.074 -342.935) scale(1.075 1.075)"
  }, "AGENDAMENTO A PARTIR DO DIA")), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "icon_data-5",
    "data-name": "icon data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-9",
    "data-name": "Ellipse",
    className: "cls-23",
    d: "M1.143,17.324a18,18,0,1,1,18,18A18,18,0,0,1,1.143,17.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Composite_Path-5",
    "data-name": "Composite Path",
    className: "cls-18",
    d: "M24.643,11.824h-1.5v-1a0.5,0.5,0,0,0-1,0v1h-6v-1a0.5,0.5,0,0,0-1,0v1h-1.5a1.5,1.5,0,0,0-1.5,1.5v9.5a1.5,1.5,0,0,0,1.5,1.5h11a1.5,1.5,0,0,0,1.5-1.5v-9.5A1.5,1.5,0,0,0,24.643,11.824Zm-11,1h1.5v1a0.5,0.5,0,0,0,1,0v-1h6v1a0.5,0.5,0,0,0,1,0v-1h1.5a0.5,0.5,0,0,1,.5.5v2h-12v-2A0.5,0.5,0,0,1,13.643,12.824Zm11,10.5h-11a0.5,0.5,0,0,1-.5-0.5v-6.5h12v6.5A0.5,0.5,0,0,1,24.643,23.324Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "linha-14",
    "data-name": "linha",
    className: "cls-20",
    d: "M-13.857-16.676h290v1h-290v-1Z"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    id: "_4_10-5",
    "data-name": "4/10",
    className: "cls-24",
    transform: "translate(-114.074 -393.915) scale(1.075 1.075)"
  }, "4/10")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    id: "PR\\xD3XIMA_SESS\\xC3O-5",
    "data-name": "PR\\xD3XIMA SESS\\xC3O",
    className: "cls-22",
    transform: "translate(-113.076 -410.935) scale(1.075 1.075)"
  }, "PR\xD3XIMA SESS\xC3O")), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "icon_sessao-5",
    "data-name": "icon sessao"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-10",
    "data-name": "Ellipse",
    className: "cls-23",
    d: "M1.143-49.676a18,18,0,0,1,18-18,18,18,0,0,1,18,18,18,18,0,0,1-18,18A18,18,0,0,1,1.143-49.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    className: "cls-25",
    d: "M26.143-47.379l-2.361-3.111L26.143-53.6h-4v-1.037h-7v-0.907a0.141,0.141,0,0,0-.151-0.13h-0.7a0.138,0.138,0,0,0-.152.126V-41.8a0.138,0.138,0,0,0,.152.126h0.7a0.138,0.138,0,0,0,.151-0.126v-6.615h4v1.037h7Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "linha-15",
    "data-name": "linha",
    className: "cls-20",
    d: "M-13.857-83.676h290v1h-290v-1Z"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    id: "Axilas-5",
    "data-name": "Axilas",
    className: "cls-26",
    x: -13.857,
    y: -129.676
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.857
  }, "Axilas"))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    className: "cls-15",
    d: "M-108.366-94.176c0-15.188,11.906-27.5,26.593-27.5h1.813c14.687,0,26.593,12.312,26.593,27.5h0c0,15.188-11.906,27.5-26.593,27.5h-1.813c-14.687,0-26.593-12.312-26.593-27.5h0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    className: "cls-16",
    d: "M-78.116-85.926l-9.167-8.25,9.167-8.25v16.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "linha-16",
    "data-name": "linha",
    className: "cls-39",
    d: "M1700-341H-108v-1H1700v1Z"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    id: "_1._Selecionar_regi\\xF5es_2._Selecionar_hor\\xE1rio_",
    "data-name": "1. Selecionar regi\\xF5es     \\u2022     2. Selecionar hor\\xE1rio     \\u2022    ",
    className: "cls-40",
    transform: "translate(796.913 -475.279) scale(2.476)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "1. Selecionar regi\xF5es", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43"
  }, "\u2022     2. Selecionar hor\xE1rio     \u2022     3. Finalizado!")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendarsesso2);
export default __webpack_public_path__ + "static/media/AGENDAR SESSÇO - 2.7fbfd2baa8f783f1b9b3f648fb2935b2.svg";
export { ForwardRef as ReactComponent };